import { format } from 'date-fns';
import ru from 'date-fns/locale/ru';
import { Pages } from 'modules/navigation/domain/enums/pages';
import MatchOverlayPreview from 'modules/championship/ui/components/match-overlay-preview';
import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import UDBreadcrumbs from 'ud-ui/components/breadcrumbs';
import UDText from 'ud-ui/components/text';
import { useMainLayout } from 'modules/app-shell/ui/layout/context';
import { selectMatchById } from 'modules/schedule/store/selectors';
import { MainBlock } from './styles';

function PreviewTemplate() {
  const navigate = useNavigate();
  const { id } = useParams();
  const match = useSelector(selectMatchById(+(id ?? 0)));
  const { setHeaderContent } = useMainLayout();
  useEffect(() => {
    if (!match) {
      toast.error('Матч не найден');
      navigate(Pages.SCHEDULE.INDEX);
    }
  }, [match, navigate]);

  const breadcrumb = useMemo(() => {
    const matchName = match
      ? `Матч: ${
          match?.date && format(new Date(match?.date), 'kk:mm dd MMMM, EEEEEE', { locale: ru })
        } ${match?.teams[0]?.name} vs ${match?.teams[1]?.name}`
      : 'Матч не найден';

    return (
      <UDBreadcrumbs
        className="my-10"
        breadcrumbs={[
          { label: 'Расписание', to: Pages.SCHEDULE.INDEX },
          {
            label: matchName,
            to: Pages.SCHEDULE.builders.view(+(id ?? 0)),
          },
        ]}
      />
    );
  }, [id, match]);

  useEffect(() => {
    setHeaderContent(breadcrumb);
    return () => setHeaderContent(null);
  }, [breadcrumb, setHeaderContent]);

  return (
    <>
      <MainBlock>
        {match ? (
          <MatchOverlayPreview game={match} championship={match.championship} />
        ) : (
          <UDText type={'caption-1'}>Матч не найден</UDText>
        )}
      </MainBlock>
    </>
  );
}

export default PreviewTemplate;
